import { Affix, Button, Card, Form, Typography } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobileView } from "../../../Common/AppHelper";
import Header from "../../../Common/Header";
import AddPackingReportTemplateForm from "./AddPackingReportTemplateForm";

export default function AddPackingReportTemplate(props) {
  const { width } = props;

  const [loading, setLoading] = useState(false);

  const { Title } = Typography;

  const formRef = useRef(null);
  const [form] = Form.useForm();

  const navigate = useNavigate();
  const discartForm = () => {
    navigate("/ex-factory/packing-report-template");
  };

  const addPackingReportTemplate = () => {
    console.log("🚀 ~ addPackingReportTemplate ~ formRef:", formRef);
    if (formRef.current) {
      formRef.current.submit();
    }
  };

  return (
    <>
      <Affix offsetTop={0}>
        <Card className="p-fixed" style={{ width: `${isMobileView() ? "100%" : `${width}px`}` }}>
          <Header
            title={<Title level={5}>Add Packing Report Template</Title>}
            subTitle=""
            addLink="/"
            addText="Add New"
            actions={[
              <Affix offsetTop={20}>
                <Button size="small" key={1} danger onClick={() => discartForm()}>
                  Discard
                </Button>
              </Affix>,
              <Affix offsetTop={20}>
                <Button
                  size="small"
                  key={2}
                  type="primary"
                  onClick={() => addPackingReportTemplate()}
                  loading={loading}
                >
                  Save Template
                </Button>
              </Affix>,
            ]}
          />
        </Card>
      </Affix>
      <AddPackingReportTemplateForm ref={formRef} form={form} setLoading={setLoading} isCreate={true} />
    </>
  );
}
